module.exports = __webpack_public_path__ + "img/joon yorigami.ff07b2cd.png";